import Store from '../store/store'
import CartItem from './../classes/CartItem'

export default class Song {

    constructor(data) {
        
        for (var i in data) {
            this[i] = data[i];
        }

        this.user = Store.state.user;
        this.loadingDownload = false;
        this.inPlayNextList = false
        this.itemId = 'song'+this.id;
    }

    // static make(songData) {
    //     let song = new Song();
        
    //     for (var i in songData) {
    //         song[i] = songData[i];
    //     }

    //     song.user = Store.state.user;
    //     song.loadingDownload = false;
    //     song.inPlayNextList = false
    //     song.itemId = this.getRandomId();

    //     return song;
    // }


    static makeArray(songsData) {
        let songs = [];

        for (var i in songsData) {
            songs.push(new Song(songsData[i]))
        }

        return songs;
    }

    inCart () {
        return Store.state.cart.inCart(this);
    }

    addToCart () {
        Store.state.cart.addItem(new CartItem(this, null, this.price, this.getType()))
    }

    getType() {
        return 'song';
    }

    shareUrl() {
        return `${ab.baseUrl}/songs/${this.id}`;
    }

    minPrice () {
        return this.price;
    }

    maxPrice () {
        return this.price;
    }

    image (size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size]
        }
        return this.user.avatar.files[size]
    }

    playTag () {
        return false;
    }

    isBeat () {
        return false;
    }

    isSong () {
        return true;
    }

    isSoundKit () {
        return false;
    }

    isCollection () {
        return false;
    }

    play () {
        Store.state.playlistManager.setPagePlaylistToCurrent()
        if (Store.state.playlistManager.getCurrentlyPlaying() &&
            Store.state.playlistManager.getCurrentlyPlaying().itemId == this.itemId) {
            Store.state.playlistManager.resume(this)

        } else {
            Store.state.playlistManager.play(this)
        }
    }

    // play () {
    //     if (Store.state.playlistManager.isPlaying(this)) {
    //         Store.state.playlistManager.resume(this)
    //     } else {
    //         Store.state.playlistManager.setPagePlaylistToCurrent()
    //         Store.state.playlistManager.play(this)
    //     }
    // }

    resume () {
        this.play()
    }

    pause () {
        Store.state.playlistManager.pause()
    }

    playNext () {
        Store.state.playlistManager.addToPlayNext(this)
    }

    isPlaying () {
        return (Store.state.playlistManager.isPlaying(this) && Store.state.player.playing)
    }

    getRandomId() {
        let number = Math.random();
        number.toString(36);
        return number.toString(36).substr(2, 9);
    }
}
